import CombatActionAttack from './CombatActionAttack';

export default CombatActionAttack;
export { CombatActionAttack };
